import { render } from "./SceneComponentRenderer.vue?vue&type=template&id=46cec202"
import script from "./SceneComponentRenderer.vue?vue&type=script&lang=js"
export * from "./SceneComponentRenderer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\state-of-green-value-chains\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__